import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/wx/wxunion/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/wx/wxunion/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/wx/wxunion/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/wx/wxunion/submit',
    method: 'post',
    data: row
  })
}

